<template>
    <main class="settings__content">
        <header class="settings__header">
            <h1 class="settings__title">
                {{ title }}
            </h1>

            <p v-if="description" class="settings__description">
                {{ description }}
            </p>
        </header>

        <slot />
    </main>
</template>

<script>
export default {
    name: 'settings-page',

    props: {
        title: {
            type: String,
            required: true,
        },

        description: {
            type: String,
            default: '',
        },
    },
};
</script>
